/* Bundle Widget — assets/bundle-widget.js */
(function(){
'use strict';

function bootAll(){
  (window.__bw||[]).forEach(function(d){ new BW(d); });
}

function BW(d){
  this.sid=d.sid;
  this.sym=d.sym;
  this.atcLabel=d.atcLabel;
  this.propLabel=d.propLabel;
  this.products=d.products;
  this.tiersArr=d.tiers;
  this.tiers={};
  this.tierKeys=[];
  for(var i=0;i<d.tiers.length;i++){
    var t=d.tiers[i];
    this.tiers[t.pick]=t;
    this.tierKeys.push(t.pick);
  }
  this.active=this.tierKeys[0];
  this.sels={};
  this.dirty={};
  for(var j=0;j<this.tierKeys.length;j++){
    this.sels[this.tierKeys[j]]=[];
    this.dirty[this.tierKeys[j]]=false;
  }
  this.aSlot=null;

  this.cache();
  this.bind();
  this.prefill();
  this.render();
  this.updAtc();
}

BW.prototype.cache=function(){
  var s=this.sid;
  this.el=document.getElementById('BW-'+s);
  this.drawer=document.getElementById('bwD-'+s);
  this.overlay=document.getElementById('bwO-'+s);
  this.dList=document.getElementById('bwDL-'+s);
  this.atcBtn=document.getElementById('bwAtc-'+s);
  this.atcPEl=document.getElementById('bwAtcP-'+s);
  this.atcLEl=document.getElementById('bwAtcL-'+s);
};

BW.prototype.bind=function(){
  var me=this;
  this.el.querySelectorAll('.bw__tier').forEach(function(c){
    c.addEventListener('click',function(e){
      if(e.target.closest('.bw__slots')) return;
      var t=parseInt(c.dataset.tier);
      if(t!==me.active){
        me.active=t;
        me.el.querySelectorAll('.bw__tier').forEach(function(x){
          x.classList.toggle('active',parseInt(x.dataset.tier)===t);
        });
        me.render();
        me.updAtc();
      }
    });
  });
  this.overlay.addEventListener('click',function(){me.closeD();});
  document.getElementById('bwDX-'+this.sid).addEventListener('click',function(){me.closeD();});
  this.atcBtn.addEventListener('click',function(){me.addToCart();});
};

BW.prototype.prefill=function(){
  for(var i=0;i<this.tierKeys.length;i++){
    var k=this.tierKeys[i],tc=this.tiers[k],dp=tc.defaultProduct;
    if(!dp) continue;
    for(var s=0;s<tc.pick;s++){
      this.sels[k].push({slot:s,product:JSON.parse(JSON.stringify(dp))});
    }
  }
};

BW.prototype.calc=function(sels,fc){
  if(!sels.length) return {free:new Set(),sub:0,disc:0,total:0};
  var sorted=sels.slice().sort(function(a,b){return a.product.price-b.product.price;});
  var free=new Set();
  for(var i=0;i<Math.min(fc,sorted.length);i++) free.add(sorted[i].slot);
  var sub=0,disc=0;
  sels.forEach(function(s){
    sub+=s.product.price;
    if(free.has(s.slot)) disc+=s.product.price;
  });
  return {free:free,sub:sub,disc:disc,total:sub-disc};
};

BW.prototype.fmt=function(n){return this.sym+n.toFixed(2);};

BW.prototype.render=function(){
  var me=this;
  this.tierKeys.forEach(function(k){
    var c=document.getElementById('sl-'+k+'-'+me.sid);
    if(!c) return;
    var tc=me.tiers[k],sels=me.sels[k];
    var pr=me.calc(sels,tc.freeCount);
    var h='';
    for(var i=0;i<tc.pick;i++){
      var sel=me.findSel(sels,i);
      if(sel){
        h+='<div class="bw__slot filled" data-slot="'+i+'" data-tier="'+k+'">'
          +'<span class="bw__slot-name">'+me.esc(sel.product.title)+'</span>'
          +'<div class="bw__slot-right">'
          +'<button class="bw__slot-remove" data-rm="'+i+'" data-rmt="'+k+'">✕</button>'
          +'<span class="bw__slot-chevron">›</span>'
          +'</div></div>';
      } else {
        h+='<div class="bw__slot" data-slot="'+i+'" data-tier="'+k+'">'
          +'<span class="bw__slot-name">'+window.__bw[0].pick_perf+' '+(i+1)+'</span>'
          +'<div class="bw__slot-right"><span class="bw__slot-chevron">›</span></div>'
          +'</div>';
      }
    }
    c.innerHTML=h;

    c.querySelectorAll('.bw__slot').forEach(function(sl){
      sl.addEventListener('click',function(e){
        if(e.target.closest('.bw__slot-remove')) return;
        var t=parseInt(sl.dataset.tier),si=parseInt(sl.dataset.slot);
        if(t===me.active) me.openD(si);
      });
    });

    c.querySelectorAll('.bw__slot-remove').forEach(function(b){
      b.addEventListener('click',function(e){
        e.stopPropagation();
        var rmTier=parseInt(b.dataset.rmt);
        me.dirty[rmTier]=true;  // ← ADD THIS
        me.sels[rmTier]=me.sels[rmTier].filter(function(s){return s.slot!==parseInt(b.dataset.rm);});
        me.render();me.updAtc();
      });
    });

    var pel=document.getElementById('tp-'+k+'-'+me.sid);
    if(!pel) return;
    if(!me.dirty[k]) return;
    if(sels.length===tc.pick){
      pel.innerHTML='<span class="bw__tier-price">'+me.fmt(pr.total)+'</span><span class="bw__tier-compare">'+me.fmt(pr.sub)+'</span>';
    } else if(sels.length>0){
      pel.innerHTML='<span class="bw__tier-price" style="font-size:13px;color:#aaa">'+sels.length+'/'+tc.pick+' izbran</span>';
    } else {
      pel.innerHTML='<span class="bw__tier-price" style="font-size:13px;color:#aaa">—</span>';
    }
  });
};

BW.prototype.updAtc=function(){
  var me=this;
  var tc=this.tiers[this.active],sels=this.sels[this.active];

  if(sels.length>=tc.pick){
    var p=this.calc(sels,tc.freeCount);
    this.atcPEl.textContent=this.fmt(p.total);
    this.atcBtn.disabled=false;
  } else {
    this.atcPEl.textContent=sels.length+' / '+tc.pick;
    this.atcBtn.disabled=true;
  }

  this.tierKeys.forEach(function(k){
    var el=document.getElementById('bwSaved-'+k+'-'+me.sid);
    var amt=document.getElementById('bwSavedAmt-'+k+'-'+me.sid);
    if(!el||!amt) return;

    if(!me.dirty[k]) return;

    var tierSels=me.sels[k];
    var tierConf=me.tiers[k];

    if(tierSels.length>=tierConf.pick){
      var p=me.calc(tierSels,tierConf.freeCount);
      if(p.disc>0){
        amt.textContent = window.__bw[0].save+' '+me.fmt(p.disc);
        el.style.display='';
      } else {
        el.style.display='none';
      }
    } else {
      amt.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M7.96887 1.24951C10.6053 1.25208 11.9694 1.29925 12.8349 2.16466C13.7003 3.03006 13.7474 4.39417 13.75 7.03064L10.679 7.03064C10.8984 6.75664 11.0623 6.43345 11.1517 6.07594C11.4881 4.7303 10.2692 3.51142 8.92358 3.84783C8.56606 3.93721 8.24288 4.10111 7.96887 4.32046L7.96887 1.24951Z" fill="white"/>              <path d="M13.75 7.96875C13.7474 10.6052 13.7003 11.9692 12.8349 12.8347C11.9694 13.7001 10.6053 13.7472 7.96887 13.7498L7.96887 8.82725C8.45619 9.80056 9.46263 10.4687 10.6251 10.4687C10.884 10.4687 11.0939 10.2589 11.0939 10C11.0939 9.74112 10.884 9.53125 10.6251 9.53125C9.66466 9.53125 8.85986 8.86456 8.64825 7.96875L13.75 7.96875Z" fill="white"/>              <path d="M7.03125 13.7497C4.39481 13.7471 3.03075 13.6999 2.16531 12.8346C1.29994 11.9691 1.25275 10.6051 1.25019 7.96863L6.35194 7.96863C6.14031 8.86444 5.3355 9.53113 4.375 9.53113C4.11613 9.53113 3.90625 9.741 3.90625 9.99988C3.90625 10.2588 4.11613 10.4686 4.375 10.4686C5.53756 10.4686 6.544 9.80044 7.03125 8.82713L7.03125 13.7497Z" fill="white"/>              <path d="M1.25019 7.03064C1.25275 4.39417 1.29994 3.03006 2.16531 2.16466C3.03075 1.29925 4.39481 1.25208 7.03125 1.24951L7.03125 4.32046C6.75725 4.10111 6.43406 3.93721 6.07663 3.84783C4.73094 3.51142 3.51206 4.7303 3.8485 6.07594C3.93788 6.43345 4.10175 6.75664 4.32112 7.03064H1.25019Z" fill="white"/><path d="M9.15063 4.75791C8.45592 4.93159 7.96855 5.55578 7.96855 6.27184V7.03121H8.72792C9.44398 7.03121 10.0682 6.54384 10.2418 5.84913C10.4066 5.1901 9.80965 4.59315 9.15063 4.75791Z" fill="white"/><path d="M7.03125 6.27184L7.03125 7.03121H6.27194C5.55588 7.03121 4.93169 6.54384 4.758 5.84913C4.59325 5.1901 5.19019 4.59315 5.84919 4.75791C6.54394 4.93159 7.03125 5.55578 7.03125 6.27184Z" fill="white"/></svg> '+tierConf.freeCount+(tierConf.freeCount>1?' AJÁNDÉK':' AJÁNDÉK');
      el.style.display='';
    }
  });
};

BW.prototype.openD=function(si){
  this.aSlot=si;
  this.renderD();
  this.drawer.classList.add('open');
  this.overlay.classList.add('open');
  document.body.style.overflow='hidden';
};

BW.prototype.closeD=function(){
  this.drawer.classList.remove('open');
  this.overlay.classList.remove('open');
  document.body.style.overflow='';
  this.aSlot=null;
};

BW.prototype.renderD=function(filter){
  filter=(filter||'').toLowerCase();
  var me=this,tc=this.tiers[this.active],sels=this.sels[this.active];
  var counts={};
  sels.forEach(function(s){counts[s.product.id]=(counts[s.product.id]||0)+1;});
  var full=sels.length>=tc.pick;
  var h='';
  this.products.forEach(function(p){
    if(filter&&p.title.toLowerCase().indexOf(filter)===-1) return;
    var cnt=counts[p.id]||0;
    var badge=p.bestseller?'<span class="bw-dp__badge">'+window.__bw[0].bestseller+'</span>':'';
    var img=p.image?'<img src="'+p.image+'" alt="" loading="lazy">':'';

    h+='<div class="bw-dp">'
      +'<div class="bw-dp__img">'+img+'</div>'
      +'<div class="bw-dp__info">'
      +'<div class="bw-dp__name">'+me.esc(p.title)+'</div>'
      +'<div class="bw-dp__variant">'+me.esc(p.variant)+'</div>'
      +'<div class="bw-dp__price">'+me.fmt(p.price)+'</div>'
      +'</div><div class="bw-dp__right">'+badge;

    if(cnt>0){
      h+='<div class="bw-dp__qty">'
        +'<button data-act="dec" data-pid="'+p.id+'">−</button>'
        +'<span>'+cnt+'</span>'
        +'<button data-act="inc" data-pid="'+p.id+'"'+(full?' disabled':'')+'>+</button>'
        +'</div>';
    } else {
      h+='<button class="bw-dp__add" data-act="add" data-pid="'+p.id+'"'+(full?' disabled':'')+'>+ '+window.__bw[0].add+'</button>';
    }
    h+='</div></div>';
  });

  this.dList.innerHTML=h;

  this.dList.querySelectorAll('[data-act]').forEach(function(b){
    b.addEventListener('click',function(){
      var pid=parseInt(b.dataset.pid);
      if(b.dataset.act==='add'||b.dataset.act==='inc') me.addP(pid);
      else me.decP(pid);
    });
  });
};

BW.prototype.addP=function(pid){
  var tc=this.tiers[this.active],sels=this.sels[this.active];
  if(sels.length>=tc.pick) return;
  var prod=null;
  for(var i=0;i<this.products.length;i++){if(this.products[i].id===pid){prod=this.products[i];break;}}
  if(!prod) return;

  var filled={};sels.forEach(function(s){filled[s.slot]=true;});
  var slot=null;
  if(this.aSlot!==null&&!filled[this.aSlot]) slot=this.aSlot;
  else for(var j=0;j<tc.pick;j++){if(!filled[j]){slot=j;break;}}
  if(slot===null) return;

  sels.push({slot:slot,product:JSON.parse(JSON.stringify(prod))});
  this.dirty[this.active]=true;
  this.render();this.renderD();this.updAtc();

  if(sels.length>=tc.pick){var me=this;setTimeout(function(){me.closeD();},350);}
};

BW.prototype.decP=function(pid){
  var sels=this.sels[this.active];
  for(var i=sels.length-1;i>=0;i--){
    if(sels[i].product.id===pid){
      sels.splice(i,1);
      this.dirty[this.active]=true;
      break;
    }
  }
  this.render();this.renderD();this.updAtc();
};

/* ══════════════════════════════════════════════════════════
   ADD TO CART — Two-step approach

   Problem: Dawn's renderContents(response) expects the
   response from a single-item /cart/add.js call which
   includes { item: {...}, sections: {...} }. But multi-item
   add returns { items: [...], sections: {...} } — different
   shape, so renderContents breaks or skips updates.

   Fix: 
   Step 1 → POST items to /cart/add.js (plain, no sections)
   Step 2 → GET current page with ?sections= param
            This gives us fresh rendered HTML for cart drawer
   Step 3 → Manually swap section HTML in DOM
   Step 4 → Open cart drawer

   Items sorted cheapest-first → show last in cart.
   ══════════════════════════════════════════════════════════ */

BW.prototype.addToCart = function(){
  var me = this;
  var tc = this.tiers[this.active];
  var sels = this.sels[this.active];
  if (sels.length < tc.pick) return;

  var pr = this.calc(sels, tc.freeCount);
  var bid = 'bw_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5);

  // Sort cheapest first → added first → appears last in cart
  var sorted = sels.slice().sort(function(a, b){ return a.product.price - b.product.price; });

  var items = sorted.map(function(s, idx){
    var props = {
      '_bundle_id': bid,
      '_bundle_tier': 'choose_' + tc.pick,
      '_bundle_position': String(idx + 1)
    };
    if (pr.free.has(s.slot)) props['_bundle_free'] = 'true';
    props[me.propLabel] = tc.label;
    return { id: s.product.variantId, quantity: 1, properties: props };
  });

  // Loading state
  this.atcBtn.disabled = true;
  this.atcLEl.textContent = 'Dodajanje...';

  // Step 1: Add items to cart (no sections param)
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
  .then(function(r){ return r.json(); })
  .then(function(res){
    if (res.status) {
      throw new Error(res.description || res.message || 'Could not add to cart');
    }
    // Step 2: Fetch fresh section HTML
    return me.fetchAndRenderCart();
  })
  .then(function(){
    me.atcLEl.textContent = 'Dodano ✓';
    setTimeout(function(){
      me.atcBtn.disabled = false;
      me.atcLEl.textContent = me.atcLabel;
    }, 1500);
  })
  .catch(function(e){
    console.error('Bundle cart error:', e);
    me.atcBtn.disabled = false;
    me.atcLEl.textContent = me.atcLabel;
  });
};

/* ──────────────────────────────────────────────
   FETCH AND RENDER CART
   Gets section IDs from Dawn's cart element,
   fetches fresh HTML via Section Rendering API,
   swaps each section in the DOM, then opens drawer.
   ────────────────────────────────────────────── */

BW.prototype.fetchAndRenderCart = function(){
  var me = this;
  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (!cart) {
    // No cart element found — redirect as fallback
    window.location = window.Shopify.routes.root + 'cart';
    return Promise.resolve();
  }

  // Get section IDs from Dawn's cart element
  var sectionsConfig = [];
  if (typeof cart.getSectionsToRender === 'function') {
    sectionsConfig = cart.getSectionsToRender();
  }

  // Build section IDs list
  var sectionIds = sectionsConfig.map(function(s){ return s.id; });
  if (!sectionIds.length) {
    // Fallback IDs for Dawn
    sectionIds = ['cart-drawer', 'cart-icon-bubble'];
  }

  // Fetch fresh sections from current page
  var url = window.location.pathname + '?sections=' + sectionIds.join(',');

  return fetch(url)
    .then(function(r){ return r.json(); })
    .then(function(sections){

      if (sectionsConfig.length) {
        // Use Dawn's config for precise DOM targeting
        sectionsConfig.forEach(function(sConf){
          var freshHtml = sections[sConf.id];
          if (!freshHtml) return;

          var tmp = document.createElement('div');
          tmp.innerHTML = freshHtml;

          // Dawn sections config has { id, selector }
          // selector targets the specific element inside the section
          var selector = sConf.selector || '#' + sConf.id;

          var target = document.querySelector(selector);
          var source = tmp.querySelector(selector);

          if (target && source) {
            target.innerHTML = source.innerHTML;
          }
        });
      } else {
        // Manual fallback
        sectionIds.forEach(function(id){
          var freshHtml = sections[id];
          if (!freshHtml) return;

          var tmp = document.createElement('div');
          tmp.innerHTML = freshHtml;

          var target = document.getElementById(id);
          if (target) {
            var source = tmp.getElementById(id) || tmp.firstElementChild;
            if (source) target.innerHTML = source.innerHTML;
          }
        });
      }

      // Remove empty state
      if (cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }

      // Open the cart
      me.openCartElement(cart);

      // Publish Dawn's PubSub event
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bundle-widget',
          cartData: sections
        });
      }
    });
};

/* ──────────────────────────────────────────────
   OPEN CART ELEMENT
   Handles both cart-drawer and cart-notification
   ────────────────────────────────────────────── */

BW.prototype.openCartElement = function(cart){
  if (!cart) return;
  var tag = cart.tagName.toLowerCase();

  if (tag === 'cart-drawer') {
    // Dawn cart-drawer uses a <details> element inside
    var details = cart.querySelector('details');
    if (details) {
      details.setAttribute('open', '');
    }
    // Some Dawn versions also need active class
    cart.classList.add('active');
    // Trap focus / prevent scroll
    document.body.classList.add('overflow-hidden');
    // Re-bind close listeners since we swapped innerHTML
    me_rebindDrawerClose(cart);
    return;
  }

  if (tag === 'cart-notification') {
    cart.classList.add('active');
    cart.removeAttribute('hidden');
    // Dawn auto-hides notification after a delay
    setTimeout(function(){
      cart.classList.remove('active');
    }, 4000);
    return;
  }
};

/* Re-bind close button after DOM swap */
function me_rebindDrawerClose(cartDrawer){
  // Dawn's close button inside cart-drawer
  var closeBtn = cartDrawer.querySelector('#cart-drawer__close') 
    || cartDrawer.querySelector('[data-drawer-close]')
    || cartDrawer.querySelector('button[aria-label="Close"]');
  
  if (closeBtn) {
    closeBtn.addEventListener('click', function(){
      var details = cartDrawer.querySelector('details');
      if (details) details.removeAttribute('open');
      cartDrawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });
  }

  // Overlay/backdrop close
  var overlay = cartDrawer.querySelector('.cart-drawer__overlay')
    || cartDrawer.querySelector('[data-drawer-overlay]');
  
  if (overlay) {
    overlay.addEventListener('click', function(){
      var details = cartDrawer.querySelector('details');
      if (details) details.removeAttribute('open');
      cartDrawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });
  }
}

/* Helpers */
BW.prototype.findSel = function(sels, i){
  for (var j = 0; j < sels.length; j++){
    if (sels[j].slot === i) return sels[j];
  }
  return null;
};

BW.prototype.esc = function(s){
  var d = document.createElement('div');
  d.textContent = s || '';
  return d.innerHTML;
};

/* Boot */
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
else bootAll();

})();